export default function IconArrowLeft() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="7.987"
      height="13.146"
      viewBox="0 0 7.987 13.146"
    >
      <path
        id="seta_voltar"
        d="M10043.377,4924.855l-5.159,5.159,5.159,5.159"
        transform="translate(-10036.804 -4923.441)"
        fill="none"
        stroke="#0abf9e"
        strokeLinecap="round"
        strokeWidth="2"
      />
    </svg>
  );
}
